import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { useAlertStore } from '@/alert/stores/AlertStore';
import SystemAlertRow from './SystemAlertRow/SystemAlertRow';
function SystemAlerts() {
    const { alerts } = useAlertStore();
    return (_jsx("div", { children: alerts.map((alert) => (_jsx(SystemAlertRow, { alert: alert }, alert.id))) }));
}
export default observer(SystemAlerts);
